import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { VariantProps } from ".";
import UnitOfMeasure from "../../UnitOfMeasure";

const Z = ({ selectedProduct }: VariantProps) => (
  <>
    <p className="price">
      {formatAsCurrency.formatIfUndefined(selectedProduct.price.price)}
      <UnitOfMeasure unitOfMeasure={selectedProduct.unitOfMeasure} />
    </p>
  </>
);

export default Z;
